<template>
<v-container fluid class="tp-page">
  <div class="tp-page-head">
    <div>
      <h1 class="tp-page-title">Encontro com Deus</h1>
      <p class="tp-page-sub">Check-in do culto infantil</p>
    </div>
    <div class="tp-head-actions">
      <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
    </div>
  </div>

  <v-row>
    <v-col cols="12" sm="12" md="6">
      <v-select
        outlined
        dense
        v-model="turmaSelecionada"
        :items="turmas"
        item-text="nome"
        item-value="id"
        label="Selecione a turma"
        color="#00695C"
        @input="carregaInscritos"
      ></v-select>
    </v-col>
  </v-row>
  <v-card class="tp-card" elevation="0" v-if="!addUser">
  <v-data-table
    :search="tabela.busca"
    :headers="tabela.cabecalho"
    :items="tabela.conteudo"
    :loading="tabela.carregamento"
    loading-text="Carregando itens..."
    sort-by="nome"
    id="printTabela"
    :hide-default-footer="imprimindo"
    :hide-default-header="imprimindo"
  >
    <template v-slot:[`item.action`]="{ item }">
      <!-- <v-icon @click="deleteItem(item)" v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE'">delete</v-icon> -->
      <v-btn icon small color="#00695C" @click="seeItem(item)">
        <v-icon small>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-row>
        <v-col>
          <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum cadastro encontrado</v-alert>
        </v-col>
      </v-row>
    </template>
    <template slot="no-results">
      <v-row>
        <v-col>
          <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
        </v-col>
      </v-row>
    </template>
    <template v-slot:[`item.dataAula`]="{ item }">
      <td>{{ formatDateBrz(item.dataAula.substring(0, 10)) }}</td>
    </template>
    <template v-slot:[`item.membro.dataNascimento`]="{ item }">
      <td>{{ calculaIdade(item.membro.dataNascimento) }} anos</td>
    </template>
    <template v-slot:[`item.membro.celulaId`]="{ item }">
      <td>{{ nomeCelula(item.membro.celulaId) }}</td>
    </template>
  </v-data-table>
  </v-card>
  <v-card-actions class="mt-2">
    <v-btn color="#00695C" dark depressed rounded class="tp-btn-add px-6" @click="printItem">Imprimir</v-btn>
  </v-card-actions>
  <v-dialog v-model="dialog" max-width="350px">
    <v-card class="tp-card" elevation="0">
      <v-card-title style="justify-content: center; padding: 8px;">
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6" md="12" style="padding: 2px;">
              <p class="texto tp-serif" style="color:#00695C">Realizar checkin manual</p>
            </v-col>
            <v-col cols="12" sm="6" md="12" style="padding: 2px;">
              <p class="texto">Nome: {{nome}}</p>
            </v-col>
            <v-col cols="12" sm="6" md="12" style="padding: 2px;">
              <p class="texto">Código: {{checkin.cod_incricao}}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions style="margin-top: -32px;padding: 20px 5px 0px;">
        <v-container fluid grid-list-md>
          <v-layout row wrap justify-center>
            <v-flex xs6 sm6 lg6>
              <v-btn :loading="loading" dark depressed block color="#00695C" style="border-radius: 7px;" large @click="realizaCheckin">Validar</v-btn>
            </v-flex>
            <v-flex xs6 sm6 lg6>
              <v-btn dark depressed block color="error" style="border-radius: 7px;" large @click="close">Fechar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogoDadosInscricao" max-width="1000px" scrollable>
    <v-card class="tp-card" elevation="0">
      <v-card-title>
        <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col cols="12" sm="12" md="12" lg="12">
              <p style="margin-bottom: 5px">Informações da inscrição</p>
              <v-divider />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-select v-model="editedItem.sexo" outlined label="Sexo" color="#00695C" :items="sexos" hide-details item-text="text" item-value="value" dense :readonly="editedIndex != -1"></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-text-field v-model="editedItem.dataNascimento" label="Data de Nascimento" outlined color="#00695C" v-mask="'##/##/####'" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-text-field v-model="editedItem.idade" label="Data de Nascimento" outlined color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field v-model="editedItem.celula" outlined label="Célula" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" v-if="editedItem.nomePai || editedItem.cpfPai || editedItem.telefonePai || editedItem.celulaPai">
              <p style="margin-bottom: 5px">Dados do pai</p>
              <v-divider />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.nomePai">
              <v-text-field v-model="editedItem.nomePai" outlined label="Nome do pai" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.cpfPai">
              <v-text-field v-model="editedItem.cpfPai" outlined label="CPF do pai" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.telefonePai">
              <v-text-field v-model="editedItem.telefonePai" outlined label="Telefone do pai" color="#00695C" dense v-mask="'(##) #####-####'" hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.celulaPai">
              <v-text-field v-model="editedItem.celulaPai" outlined label="Célula do pai" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" v-if="editedItem.nomeMae || editedItem.cpfMae || editedItem.telefoneMae || editedItem.celulaMae">
              <p style="margin-bottom: 5px">Dados da mãe</p>
              <v-divider />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.nomeMae">
              <v-text-field v-model="editedItem.nomeMae" outlined label="Nome da mãe" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.cpfMae">
              <v-text-field v-model="editedItem.cpfMae" outlined label="CPF da mãe" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.telefoneMae">
              <v-text-field v-model="editedItem.telefoneMae" outlined label="Telefone da mãe" color="#00695C" dense v-mask="'(##) #####-####'" hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.celulaMae">
              <v-text-field v-model="editedItem.celulaMae" outlined label="Célula da mãe" color="#00695C" dense hide-details :readonly="editedIndex != -1"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="#00695C" text large @click="close">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
  <Snackbar ref=chamaSnackbar />
  <div v-show="true">
    <Inscricoes ref="inscricoes"></Inscricoes>
  </div>
</v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  baseApiUrl
} from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import Inscricoes from '../componentes/inscricoes.vue'
import moment from 'moment'
import axios from 'axios'
import PH from 'print-html-element'
import {
  mapState
} from 'vuex'
export default {
  components: {
    Snackbar,
    Loading,
    Inscricoes,
  },
  data: vm => ({
    dialogoDadosInscricao: false,
    turmaSelecionada: '',
    fullPage: true,
    isLoading: false,
    loading: false,
    search: '',
    nome: '',
    addUser: false,
    dialog: false,
    checkin: {
      cod_incricao: '',
      tipo: '',
      eventoId: '',
      userValidatorId: '',
    },
    tabela: {
      busca: '',
      cabecalho: [
        { text: 'Nome', align: 'start', value: 'membro.nome', },
        { text: 'Célula', value: 'membro.celulaId' },
        { text: 'Idade', value: 'membro.dataNascimento' },
        { text: 'Turma', value: 'turma.nome' },
        { text: 'Data', value: 'dataAula' },
        { text: 'Ações', value: 'action', align: 'center', sortable: true },
      ],
      carregamento: false,
      conteudo: []
    },
    statusPagamento: ['CANCELADO','ESTORNADO','PAGO','PENDENTE'],
    sexos: ['MASCULINO','FEMININO'],
    tipos: ['MEMBRO','VISITANTE'],
    formaPagamento: [
      { value: 'BOLETO', text: 'BOLETO'},
      { value: 'CARTAO', text: 'CARTÃO'},
      { value: 'CORTESIA', text: 'CORTESIA'},
      { value: 'EM MAOS', text: 'EM MÃOS'},
      { value: 'PIX', text: 'PIX'},
    ],
    editedIndex: -1,
    editedItem: {
      nome: '',
      sexo: '',
      dataNascimento: '',
      celula: '',
      idade: '',
      nomeMae: '',
      cpfMae: '',
      telefoneMae: '',
      celulaMae: '',
      nomePai: '',
      cpfPai: '',
      telefonePai: '',
      celulaPai: '',
    },
    defaultItem: {
      nome: '',
      sexo: '',
      dataNascimento: '',
      celula: '',
      idade: '',
      nomeMae: '',
      cpfMae: '',
      telefoneMae: '',
      celulaMae: '',
      nomePai: '',
      cpfPai: '',
      telefonePai: '',
      celulaPai: '',
    },
    turmas: [],
    inscritos: [],
    celulas: [],
    dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
    dataSelecionada: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu1: false,
    imprimindo: false,
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'FICHA DE INSCRIÇÃO' : 'FICHA DE INSCRIÇÃO'
    },
    computedDateFormattedInicio () {
      return this.formatDate(this.dataSelecionada)
    },
  }),

  watch: {
    dataSelecionada() {
      this.dateFormattedInicio = this.formatDate(this.dataSelecionada)
    },
  },

  mounted() {
    this.carregaCelulas()
    this.carregaTurmas()
  },

  methods: {
    printItem() {
      this.imprimindo = true
      var opts = {
        pageTitle: "Inscrições para o culto infantil do dia " + this.dateFormattedInicio
      }
      setTimeout(() => {
        PH.printElement(document.getElementById('printTabela'), opts)
        this.imprimindo = false
      }, 50);
    },

    async carregaCelulas() {
      await axios.get(baseApiUrl + 'Celulas?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "fields":{"nome": true, "id": true}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data.length > 0) {
          this.celulas = response.data
        }
      })
    },

    async carregaTurmas() {
      await axios.get(baseApiUrl + 'Turmas?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "order": "nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          this.turmas = response.data
        }
      })
    },

    async carregaInscritos() {
      this.tabela.conteudo = []
      this.tabela.carregamento = true
      await axios.get(baseApiUrl + 'MembrosTurmas?filter={"where":{"and":[{"dataAula":"2024-05-03T00:00:00.000Z"},{"turmaId":"' + this.turmaSelecionada + '"}]}, "include":["turma", "membro"]}&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          this.tabela.conteudo = response.data
        }
      })
      this.tabela.carregamento = false
    },

    preparaImpressao(array) {
      var pr = this;
      pr.$refs.inscricoes.preparaImpressao(array)
    },

    print() {
      var vm = this;
      vm.$refs.inscricoes.print();
    },

    async save() {
      this.isLoading = true
      if (this.editedIndex != -1) {
        this.editedItem.nome = this.editedItem.nome
        this.editedItem.cpf = this.editedItem.cpf
        this.editedItem.email = this.editedItem.email.trim()
        this.editedItem.statusPagamento = this.editedItem.statusPagamento
        await axios.patch(`${baseApiUrl}inscricoes/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
        .then(res => {
          if (res.data != null) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaTurmas()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      } else {
        this.editedItem.empresaId = this.companyobj.id
        await axios.post(`${baseApiUrl}Eventos/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem).then(res => {
          this.id_evento = res.data.id
          if (res.data != null) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Evento cadastrado com sucesso!", "INFORMAÇÃO")
            this.carregaTurmas()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar evento, tente novamente", "ERRO")
        })
      }
      this.close()
    },

    compare(a) {
      // Use toUpperCase() to ignore character casing
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
      //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
      const dataC = moment().format()

      let comparison = 0;
      if (dataC >= dataA)
        comparison = 1;
      /* else if (dataA >= dataC && dataB < dataA)
        comparison = -1; */
      else if (dataC < dataA)
        comparison = -1;
      return comparison;
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHour(data_hora) {
      let data = data_hora.substr(0, 10).split('-')
      data = data[2] + '/' + data[1] + '/' + data[0]
      let hora = data_hora.substr(11, 8)

      return data + ' ' + hora

    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    calculaIdade(dataNasc) {
      let dataAtual = new Date();
      let anoAtual = dataAtual.getFullYear();
      let anoNascParts = dataNasc.split('/');
      let diaNasc = anoNascParts[0];
      let mesNasc = anoNascParts[1];
      let anoNasc = anoNascParts[2];
      let idade = anoAtual - anoNasc;
      let mesAtual = dataAtual.getMonth() + 1;
      // Caso mês atual for menor que o de nascimento, não fez aniversário ainda;
      if (mesAtual < mesNasc) {
        idade--;
      } else {
        // Estando no mês do nascimento, verifica o dia
        if (mesAtual == mesNasc) {
          if (new Date().getDate() < diaNasc ) {
            // Caso a data atual for menor que o dia de nascimento, ainda não fez aniversário
            idade--;
          }
        }
      }
      return idade;
    },

    nomeCelula(celulaId) {
      let nomeCelula
      this.celulas.filter(celula => {
        if (celula.id === celulaId) {
          nomeCelula = celula.nome
        }
      })
      return nomeCelula
    },

    async realizaCheckin() {
      this.loading = true
      await axios.post(`${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem('accToken')}`, this.checkin)
        .then(res => {
          if (res.data != '') {
            switch (res.data.codigo) {
              case 3:
                //'Checkin confirmado
                this.loading = false
                this.close()
                var vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin realizada com sucesso!", "INFORMAÇÃO")
                break;
              case 1:
                //'Checkin ja realizado'
                this.close()
                vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin já realizado!", "INFORMAÇÃO")
                this.loading = false
                break;
              default:
                break;
            }
          } else {
            vm = this
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      await this.carregaInscritos()
      this.checkin.cod_incricao = ''
      this.checkin.tipo = ''
      this.checkin.eventoId = ''
      this.checkin.userValidatorId = ''
    },

    openDialog(item) {
      this.checkin.cod_incricao = item.cod_incricao
      this.checkin.tipo = 'CHECKIN'
      this.checkin.eventoId = this.turmaSelecionada
      this.checkin.userValidatorId = this.user.id
      this.nome = item.nome
      this.dialog = true
    },

    async editItem(item) {
      this.isLoading = true
      this.editedIndex = this.inscritos.indexOf(item)
      try {
        await axios.get(`${baseApiUrl}inscricoes/${item.id}?access_token=${sessionStorage.getItem('accToken')}`).then(response => {
          if (response.data) {
            this.pegaImagem(response.data.id)
            this.editedItem.nome = response.data.nome
            this.editedItem.cpf = response.data.cpf
            this.editedItem.email = response.data.email
            this.editedItem.statusPagamento = response.data.statusPagamento
            this.editedItem.id = response.data.id
            this.editedItem.telefone = response.data.telefone
            this.editedItem.cargo = response.data.cargo
            this.editedItem.empresa = response.data.empresa
            this.editedItem.nomeCracha = response.data.nomeCracha
            this.editedItem.tipo = response.data.tipo
            this.editedItem.sexo = response.data.sexo
            this.editedItem.celula = response.data.celula
            this.editedItem.infoVacina = this.exibeInformacaoVacina(response.data.infoVacina)
            this.editedItem.formOfPayment = response.data.formOfPayment
            this.editedItem.valorPago = response.data.valorPago
            this.editedItem.codigoTransacao = response.data.codigoTransacao
            this.editedItem.numero = response.data.numero
            this.editedItem.participantes = response.data.participantes
            this.dialogoDadosInscricao = true
            this.isLoading = false
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao editar inscrição", "DESCULPE")
      }
    },

    async pegaImagem(idInscricao) {
      await axios.get(`${baseApiUrl}ImagesDocs?filter={"where":{"inscricaoId":"${idInscricao}"}}&access_token=${sessionStorage.getItem('accToken')}`)
      .then(response => {
        if (response.data.length != 0) {
          this.editedItem.arquivoComprovanteVacinal = response.data[0].arquivoComprovanteVacinal
        }
      })
    },

    async sendEmail(item) {
      this.isLoading = true
      this.editedItem.id = item.id
      try {
        await axios.post(`${baseApiUrl}Inscricoes/EmailRecuperaAcesso?access_token=${sessionStorage.getItem('accToken')}`, {"inscricaoId": this.editedItem.id} ).then(res => {
          if (res.data) {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "E-mail enviado com sucesso!", "SUCESSO")
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao enviar e-mail, tente novamente", "DESCULPE")
      }
    },

    async deleteItem(item) {
      var r = confirm('Deseja realmente excluir: ' + item.nome + ' do evento?')
      if (r == true) {
        this.isLoading = true
        await axios.delete(`${baseApiUrl}Inscricoes/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaTurmas()
            //this.eventoId = this.eventoIdAtual
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
      }
    },

    close() {
      this.dialog = false
      this.dialogoDadosInscricao = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async seeItem(item) {
      this.isLoading = true
      this.editedIndex = this.inscritos.indexOf(item)
      let maeResponse = ''
      let paiResponse = ''
      if (item.membro.maeId) {
        maeResponse = await axios.get(baseApiUrl + 'Membros/' + item.membro.maeId + '?access_token=' + sessionStorage.getItem('accToken'))
      }
      if (item.membro.paiId) {
        paiResponse = await axios.get(baseApiUrl + 'Membros/' + item.membro.paiId + '?access_token=' + sessionStorage.getItem('accToken'))
      }
      let dados = {
        "nome": item.membro.nome,
        "sexo": item.membro.sexo,
        "dataNascimento": item.membro.dataNascimento,
        "celula": this.nomeCelula(item.membro.celulaId),
        "idade": this.calculaIdade(item.membro.dataNascimento) + ' anos',
        "nomeMae": maeResponse != '' ? maeResponse.data.nome : '',
        "cpfMae": maeResponse != '' ? maeResponse.data.cpf : '',
        "telefoneMae": maeResponse != '' ? maeResponse.data.telefone : '',
        "celulaMae": maeResponse != '' ? this.nomeCelula(maeResponse.data.celulaId).trim() : '',
        "nomePai": paiResponse != '' ? paiResponse.data.nome : '',
        "cpfPai": paiResponse != '' ? paiResponse.data.cpf : '',
        "telefonePai": paiResponse != '' ? paiResponse.data.telefone : '',
        "celulaPai": paiResponse != '' ? this.nomeCelula(paiResponse.data.celulaId).trim() : '',
        "id": item.membro.id,
      }
      this.editedItem = Object.assign({}, dados)
      this.dialogoDadosInscricao = true
      this.isLoading = false
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    allowedDates: val => {
      var dayOfWeek = new Date(val).getDay();    
      return dayOfWeek == 6;
    }
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url('https://fonts.google.com/specimen/Roboto');
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
